import { useCallback, useEffect, useState } from "react";
import request from "superagent";
import { BACKEND_URL } from "../config/config";
import { subscribe } from "../utils/pubsub";
import useSessionToken from "./useSessionToken";

const cache: { [uuid: string]: any } = {};

function useProfileDetails(uuid = "me") {
  const sessionToken = useSessionToken();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const loadProfileData = useCallback(() => {
    // eslint-disable-next-line no-prototype-builtins
    console.log("useprofil");
    request
      .get(BACKEND_URL + `api/profile/${uuid}`)
      .set("Authorization", `Bearer ${sessionToken}`)
      .then((res) => {
        const name = res.body.displayName ?? "-";
        const email = res.body.email;
        const firstName = res.body.userData.first_name;
        const lastName = res.body.userData.last_name;

        cache[uuid] = { name, email };
        setName(name);
        setEmail(email);
        setFirstName(firstName);
        setLastName(lastName);
      })
      .catch(() => {
        setName("");
        setEmail("");
      });
  }, [sessionToken, uuid]);

  useEffect(() => {
    loadProfileData();
  }, [loadProfileData]);

  subscribe("user", ({ event }) => {
    if (event === "updated") {
      loadProfileData();
    }
  });

  return { name, email, firstName, lastName };
}

export default useProfileDetails;
